import React, { useState, useEffect, useRef } from "react";
import Grid from "@mui/material/Grid2";

import { 
  Campaign, 
} from "@dndModels";

import ToastBox from "@components/display/ToastBox";
import CommonUtilities from "@utilities/common_utilities";
import CampaignPlayerInput from "./CampaignPlayerInput";
import ShareButton from "@components/input/buttons/ShareButton";
import FlexBox from "@components/layout/FlexBox";

const common_util = CommonUtilities.getInstance();

interface Props {
  obj: Campaign;
}

export default function CampaignPlayersInput({ obj }: Props) {
  const [reloading, setReloading] = useState(false);
  const [toast_time, setToastTime] = useState(0);
  const mounted = useRef(false);

  useEffect(() => { 
    mounted.current = true;

    return () => {
      mounted.current = false;
    };
  }, []);
    
  useEffect(() => {
    if (reloading) {
      setReloading(false);
    }
  }, [reloading, setReloading]);

  return (
    <FlexBox direction="column">
      <FlexBox>
        <ShareButton
          label="Share Invite Link"
          onClick={() => {
            navigator.clipboard.writeText(`${window.location.origin}/campaign/join/${obj._id}/${obj.reusable_invite}`);
            setToastTime(common_util.get_time_number());
          }}
        />
        <ToastBox
          openTime={ toast_time }
        >
          Link copied to Clipboard
        </ToastBox>
      </FlexBox>
      <Grid container spacing={0} direction="row">
        { obj.players.map(player => {
          return (
            <Grid size={4} key={player._id}>
              <CampaignPlayerInput
                campaign={obj}
                player={player}
                onUpdated={() => { setReloading(true); }}
              />
            </Grid>
          );
        })}
      </Grid>
    </FlexBox>
  );
}
